import { render } from "./BrucdcumHeader.vue?vue&type=template&id=7792efe8"
import script from "./BrucdcumHeader.vue?vue&type=script&lang=js"
export * from "./BrucdcumHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__